import comp from "./SharepointPicker";
export default comp;
